import { schemeColor } from 'shared/assets/styles/scheme-color.style';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${({ theme }) => theme.spacing(0, 2)};
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const IconContainer = styled.div<{ $color?: string | null }>`
  color: ${({ $color, theme }) => schemeColor($color, theme)};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
`;
